import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [cookiesAccepted, setCookiesAccepted] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (accepted) {
      setCookiesAccepted(true);
    } else {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  // Generar un deviceId más robusto basado en características del navegador
  const generateDeviceId = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Device fingerprint', 2, 2);
    
    const fingerprint = [
      navigator.userAgent,
      navigator.language,
      window.screen.width + 'x' + window.screen.height,
      window.screen.colorDepth,
      new Date().getTimezoneOffset(),
      canvas.toDataURL(),
      navigator.hardwareConcurrency || 'unknown',
      navigator.deviceMemory || 'unknown'
    ].join('|');
    
    // Crear un hash simple del fingerprint
    let hash = 0;
    for (let i = 0; i < fingerprint.length; i++) {
      const char = fingerprint.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convertir a 32bit integer
    }
    
    const timestamp = Date.now();
    const randomPart = Math.random().toString(36).substr(2, 9);
    
    return `device_${Math.abs(hash).toString(36)}_${timestamp}_${randomPart}`;
  };

  // Obtener la IP del usuario cuando acepta las cookies
  const getUserIP = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error obteniendo IP:', error);
      return null;
    }
  };

  const handleAcceptCookies = async () => {
    try {
      // Marcar cookies como aceptadas
      localStorage.setItem('cookiesAccepted', 'true');
      
      // Generar y guardar deviceId
      const deviceId = generateDeviceId();
      localStorage.setItem('deviceId', deviceId);
      
      // Obtener y guardar la IP del usuario
      const userIP = await getUserIP();
      if (userIP) {
        localStorage.setItem('userIP', userIP);
        console.log('IP del usuario obtenida:', userIP);
      }
      
      // Guardar timestamp de cuando se aceptaron las cookies
      localStorage.setItem('cookiesAcceptedAt', new Date().toISOString());
      
      console.log('Cookies aceptadas, deviceId generado:', deviceId);
      
      setCookiesAccepted(true);
      setIsVisible(false);
      
      // Disparar evento personalizado para notificar a otros componentes
      window.dispatchEvent(new CustomEvent('cookiesAccepted', {
        detail: { deviceId, userIP }
      }));
      
    } catch (error) {
      console.error('Error al procesar la aceptación de cookies:', error);
      // Continuar con el proceso aunque haya errores
      setCookiesAccepted(true);
      setIsVisible(false);
    }
  };

  const handleRejectCookies = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    localStorage.setItem('cookiesRejectedAt', new Date().toISOString());
    setIsVisible(false);
    
    // Limpiar cualquier dato previo relacionado con tracking
    localStorage.removeItem('deviceId');
    localStorage.removeItem('userIP');
    
    console.log('Cookies rechazadas, datos de tracking eliminados');
  };

  if (cookiesAccepted || !isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="max-w-4xl mx-auto bg-white shadow-2xl rounded-lg p-6 border border-gray-200">
        <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6">
          <div className="flex-grow">
            <h2 className="text-xl font-bold text-gray-800 mb-2">
              🍪 Este sitio web utiliza cookies
            </h2>
            <p className="text-gray-600 mb-2">
              Utilizamos cookies para mejorar tu experiencia de navegación, 
              analizar el tráfico del sitio y personalizar el contenido.
            </p>
            <p className="text-sm text-gray-500">
              Al aceptar, también recopilaremos información anónima sobre tu dispositivo 
              y actividad de navegación para mejorar nuestros servicios.
            </p>
          </div>
          <div className="flex space-x-4">
            <button 
              onClick={handleRejectCookies}
              className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md 
                         hover:bg-gray-100 transition-colors duration-300"
            >
              Rechazar
            </button>
            <button 
              onClick={handleAcceptCookies}
              className="px-4 py-2 bg-blue-600 text-white rounded-md 
                         hover:bg-blue-700 transition-colors duration-300"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;